import script from "./moduleCheckBox.vue?vue&type=script&setup=true&lang=js"
export * from "./moduleCheckBox.vue?vue&type=script&setup=true&lang=js"

import "./moduleCheckBox.vue?vue&type=style&index=0&id=1e64bfd2&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e64bfd2"]])

export default __exports__